import { Button } from '@material-tailwind/react';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import { initMercadoPago, Wallet  } from '@mercadopago/sdk-react'
import { TbLoader3 } from 'react-icons/tb';

const initialOptions = {
    // clientId: "AcZhPnx-9ll1BXRP_aeKTIHSX7I-H6AeQxxP5P44ykgGTawDYRZlqNxA6bc7ISGtZRzIut9j604T0prr",
    clientId: "ARSlRg913gSIHJDgHHDAv3TQFQMfG7vunewPdNtmA3FwE2gA2ckXLEVLzg4FoG-lTad5La_kePLc2MDb",
    currency: "MXN",
    intent: "capture",
    locale: "es_MX",
    "disable-funding": "card"
};

const AbonoSelect = () => {

    initMercadoPago('APP_USR-49b7d7d8-934a-4872-9a1b-1f7b364ee4d1', {
        locale: 'es-MX'
    });

    const { email, total, folio, id } = useParams();

    const [preferencedId, setPreferencedId] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        sessionStorage.removeItem('factura_abonoMV');
        if(email && total && folio && id){
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if(!regex.test(email)){
                window.location.href = '/';
            }
            fetch('https://muebleria-villarreal.com/apimv/getEstadoCuentaController.php?cliente=' + id)
                .then(response => response.json())
                .then(data => {
                    // Check if there is an object with the exact folio
                    const factura = data.estadoCuentaFact.find(item => item.folio === folio);
                    if (!factura) {
                        window.location.href = '/';
                    } else {
                        // console.log('Factura encontrada:', factura);
                        sessionStorage.setItem('factura_abonoMV', JSON.stringify(factura));
                    }
                })
                .then(() => {
                    
                    fetch("https://muebleria-villarreal.com/apimv/getMPPreferenceAbonoController.php?total_venta=" + total)
                        .then(response => response.json())
                        .then(data => {
                            setPreferencedId(data);
                            setLoading(false);
                        })
                })
        } else {
            window.location.href = '/';
        }
    },[email, total, folio, id])

  return (
    <section className='w-full h-screen flex flex-col items-center justify-center'>
        {
            loading &&
            <div className='w-full h-lvh bg-white bg-opacity-80 flex justify-center items-center fixed top-0 left-0 z-40'>
                <TbLoader3 className='stroke-azul animate-spin h-20 w-20' />
            </div>
        }
        <div className='w-full h-full flex flex-col items-center justify-center relative z-10'>
            <h1 className='text-2xl font-bold'>Selecciona el metodo de pago</h1>
            <div className='flex flex-row items-start justify-center gap-4 pt-2'>
                <div className='pt-4'>
                    <PayPalScriptProvider options={initialOptions}>
                        <PayPalButtons
                            style={{
                                layout: 'horizontal',
                                size: 'responsive',
                                height: 48,
                                width: 250,
                                
                            }}
                            createOrder={(data, actions) => {
                                setLoading(true);
                                return actions.order.create({
                                    intent: "CAPTURE",
                                    purchase_units: [
                                        {
                                            amount: {
                                                value: (total)
                                            },
                                        },
                                    ],
                                });
                            }}
                            onApprove={async (data, actions) => {
                                const order = await actions.order.capture();
                                // console.log(order);
                                window.location.href = `/cliente/abono/pay?payment_id=${order.id}&payment_type=Paypal&total_venta=${total}`;
                            }}
                            onError={(err) => {
                                setLoading(false);
                                console.log(err);
                            }}
                        />
                    </PayPalScriptProvider>

                </div>
                <Wallet initialization={{ preferenceId: preferencedId }} customization={{ texts:{ valueProp: 'smart_option'}}} />
            </div>
        </div>
    </section>
  )
}

export default AbonoSelect